import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import rest from '../axios';
import './css/comentarios.css';

const ComentariosComponent = () => {
  const [comentarios, setComentarios] = useState([]);
  const [allComentarios, setAllComentarios] = useState([]);
  const [providers, setProviders] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedComentario, setSelectedComentario] = useState(null);

  useEffect(() => {
    Promise.all([
      rest.get('/comments'),
      rest.get('/admin/providers'),
      rest.get('/admin/users'),
    ])
      .then(([comentariosRes, providersRes, usersRes]) => {
        setComentarios(comentariosRes.data?.data);
        setAllComentarios(comentariosRes.data?.data);
        setProviders(providersRes.data?.data);
        setUsers(usersRes.data?.data?.users);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar dados:', error);
        setLoading(false);
      });
  }, []);

  const filterTable = () => {
    let filteredComentarios = allComentarios;

    // Filtro de pesquisa
    if (search) {
      const filter = search.toLowerCase();
      filteredComentarios = filteredComentarios.filter((comentario) =>
        comentario.provider_name.toLowerCase().includes(filter) ||
        comentario.user_name.toLowerCase().includes(filter) ||
        comentario.comment.toLowerCase().includes(filter)
      );
    }

    // Filtro por intervalo de datas
    if (startDate) {
      const start = new Date(startDate).setHours(0, 0, 0, 0); // Começo do dia
      filteredComentarios = filteredComentarios.filter((comentario) =>
        new Date(comentario.created_at).getTime() >= start
      );
    }

    if (endDate) {
      const end = new Date(endDate).setHours(23, 59, 59, 999); // Fim do dia
      filteredComentarios = filteredComentarios.filter((comentario) =>
        new Date(comentario.created_at).getTime() <= end
      );
    }

    setComentarios(filteredComentarios);
  };

  const handleAddComentario = () => {
    const newComentario = {
      providerId: Number(selectedComentario.provider_id),
      userId: Number(selectedComentario.user_id),
      rating: Number(selectedComentario.rating),
      comment: selectedComentario.comment,
    };

    rest.post('/comments', newComentario)
      .then(() => {
        setShowAddModal(false);
        setLoading(true);
        rest.get('/comments')
          .then((response) => {
            setComentarios(response.data?.data);
            setAllComentarios(response.data?.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Erro ao carregar comentários:', error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error('Erro ao adicionar comentário:', error);
        setLoading(false);
      });
  };

  const handleEditComentario = (id) => {
    const updatedComentario = {
      provider_id: selectedComentario.provider_id,
      user_id: selectedComentario.user_id,
      rating: selectedComentario.rating?.rating,
      comment: selectedComentario.comment,
    };

    rest.put(`/comments/${id}`, updatedComentario)
      .then(() => {
        setShowEditModal(false);
        setLoading(true);
        rest.get('/comments')
          .then((response) => {
            setComentarios(response.data?.data);
            setAllComentarios(response.data?.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Erro ao carregar comentários:', error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error('Erro ao editar comentário:', error);
        setLoading(false);
      });
  };

  const handleDeleteComentario = (id) => {
    rest.delete(`/comments/${id}`)
      .then(() => {
        setShowDeleteModal(false);
        setLoading(true);
        rest.get('/comments')
          .then((response) => {
            setComentarios(response.data?.data);
            setAllComentarios(response.data?.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Erro ao carregar comentários:', error);
            setLoading(false);
          });
      })
      .catch((error) => {
        console.error('Erro ao excluir comentário:', error);
        setLoading(false);
      });
  };

  return (
    <div className="container wrapperi">
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Pesquisar por prestador, usuário ou comentário..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              filterTable();
            }}
          />
          <div className="d-flex mb-3">
            <Form.Control
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                filterTable();
              }}
              className="me-2"
            />
            <Form.Control
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                filterTable();
              }}
            />
          </div>
          <div>
            <strong>{comentarios.length}</strong> Comentários encontrados
          </div>
          <Button variant="primary" onClick={() => setShowAddModal(true)}>
            Adicionar Comentário
          </Button>

          <div className="table-wrapperi">
            <table className="table mt-4">
              <thead>
                <tr>
                  <th>Prestador</th>
                  <th>Usuário</th>
                  <th>Avaliação</th>
                  <th>Comentário</th>
                  <th>Data do Comentário</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {comentarios.map((comentario) => (
                  <tr key={comentario.id}>
                    <td>{comentario.provider.name}</td>
                    <td>{comentario.user.first_name} {comentario.user.last_name}</td>
                    <td>{comentario.rating?.rating}</td>
                    <td>{comentario.comment}</td>
                    <td>{new Date(comentario.created_at).toLocaleString()}</td>
                    <td>
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedComentario(comentario);
                          setShowEditModal(true);
                        }}
                      >
                        Editar
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => {
                          setSelectedComentario(comentario);
                          setShowDeleteModal(true);
                        }}
                      >
                        Excluir
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal Adicionar Comentário */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Comentário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Prestador</Form.Label>
              <Form.Control as="select" name="provider_id" onChange={(e) => setSelectedComentario({ ...selectedComentario, provider_id: e.target.value })}>
                {providers.length > 0 ? (
                  providers.map((provider) => (
                    <option key={provider.id} value={provider.id}>{provider.name}</option>
                  ))
                ) : (
                  <option value="">Carregando Prestadores...</option>
                )}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Usuário</Form.Label>
              <Form.Control as="select" name="user_id" onChange={(e) => setSelectedComentario({ ...selectedComentario, user_id: e.target.value })}>
                {users.length > 0 ? (
                  users.map((user) => (
                    <option key={user.id} value={user.id}>{user.first_name} {user.last_name}</option>
                  ))
                ) : (
                  <option value="">Carregando Usuários...</option>
                )}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Avaliação</Form.Label>
              <Form.Control type="number" name="rating" min="1" max="5" onChange={(e) => setSelectedComentario({ ...selectedComentario, rating: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Comentário</Form.Label>
              <Form.Control as="textarea" name="comment" onChange={(e) => setSelectedComentario({ ...selectedComentario, comment: e.target.value })} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAddComentario}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Editar Comentário */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Comentário</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Comentário</Form.Label>
              <Form.Control as="textarea" name="comment" defaultValue={selectedComentario?.comment} onChange={(e) => setSelectedComentario({ ...selectedComentario, comment: e.target.value })} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={() => handleEditComentario(selectedComentario.id)}>
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Excluir Comentário</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>Tem certeza de que deseja excluir este comentário?</p>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
      Cancelar
    </Button>
    <Button variant="danger" onClick={() => handleDeleteComentario(selectedComentario.id)}>
      Excluir
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default ComentariosComponent;
